module.exports = __webpack_public_path__ + "static/JosiahRiningerResume-9e073e8683a0a46454b40a8ba27cf260.pdf";